let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6fbhv")).then(() => parcelRequire('3JqYA'));